// PLUGINS IMPORTS //
import React from 'react'
import styled from 'styled-components/macro'

// COMPONENTS IMPORTS //
import { memoComparison } from 'Content/Shared/Helpers/Functions/Functions'

// EXTRA IMPORTS //

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  selectedVar: VarType
  setSelectedVar: (newSelectedVar: VarType) => void
}

const HeaderSelector: React.FC<PropsType> = (props) => {
  return (
    <Wrapper>
      <Selector>
        {data.map((item) => {
          const isSelected = item === props.selectedVar
          return (
            <ItemWrap
              onClick={() => props.setSelectedVar(item)}
              isSelected={isSelected}
            >
              <span>{item}</span>
            </ItemWrap>
          )
        })}
      </Selector>
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

export type VarType = 'Projects' | 'Exposition'
const data: Array<VarType> = [
  // 'Projects',
  'Exposition',
]

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 70px;
`

const BORDER_RADIUS = '10px'
const Selector = styled.div`
  background-color: #191919;
  flex-direction: row;
  display: flex;

  box-shadow: 0px 50px 100px rgba(0, 0, 0, 0.25),
    inset 0px 0px 0px 0.5px rgba(255, 255, 255, 0.2);
  border-radius: ${BORDER_RADIUS};
`

const ItemWrap = styled.div`
  cursor: pointer;
  width: 140px;
  height: 30px;
  border-radius: ${BORDER_RADIUS};
  background-color: ${(props: { isSelected: boolean }) =>
    props.isSelected && '#5B5B60'};
  display: flex;
  justify-content: center;
  align-items: center;
`

export default React.memo(HeaderSelector, memoComparison)
